import localforage from 'localforage'

localforage.config({
  name: 'AgentSamplingDB'
})

export default localforage
